// extracted by mini-css-extract-plugin
export var button = "_dv-0";
export var icon = "_dv-1";